
import { Vue3Mq } from 'vue3-mq'

export default {
  install: (app) => {
    app.use(Vue3Mq, {
      breakpoints: {
        phone: 0,
        smtablet: 600,
        tablet: 1025,
        desktop: 1367

      }
    })
  }
}
